import React from 'react';
import { Box, Group } from '@mantine/core';
import { LanguageSelector, ThemeToggle } from '../../common';
import {
  HomeButton,
  NewContentButton,
  LogoutButton,
  ClearAllButton,
  StatusBadge,
} from './components';
import styles from './Header.module.scss';

interface HeaderProps {
  isMobile?: boolean;
  isTablet?: boolean;
  onThemeToggle: () => void;
  isDark: boolean;
  onClearAll: () => void;
  status: string;
  version: string;
  isLoading: boolean;
  onRecheckHealth: () => void;
}

export const Header: React.FC<HeaderProps> = ({
  isMobile = false,
  isTablet = false,
  onThemeToggle,
  isDark,
  onClearAll,
  status,
  version,
  isLoading,
  onRecheckHealth,
}) => {
  return (
    <Box
      component="header"
      h={isMobile ? 50 : isTablet ? 55 : 60}
      px={isMobile ? 'xs' : isTablet ? 'sm' : 'md'}
      py="xs"
    >
      <div className={styles.header__container}>
        <Group className={styles.header__group}>
          <HomeButton />
          <NewContentButton isMobile={isMobile} isTablet={isTablet} />
          <ClearAllButton isMobile={isMobile} isTablet={isTablet} onClearAll={onClearAll} />
        </Group>
        <Group className={styles.header__group}>
          <StatusBadge
            status={status}
            version={version}
            isLoading={isLoading}
            onRecheck={onRecheckHealth}
          />
          <ThemeToggle onToggle={onThemeToggle} isDark={isDark} />
          <LanguageSelector />
          <LogoutButton isMobile={isMobile} isTablet={isTablet} />
        </Group>
      </div>
    </Box>
  );
};
